import fetch from '../utils/fetch';
import RecognitionEverywhereSDK from '@nackle/recognition-everywhere-sdk';
import { COMPANY_STORAGE_KEY } from '../../constants';
import { getUser } from 'app/app-auth';

function RecognitionService() {
    let sdk = null;

    const recognitionServiceRefresh = async () => {
        const user = getUser();
        const companyId = user?.claims?.company_id || localStorage.getItem( COMPANY_STORAGE_KEY );
        sdk = new RecognitionEverywhereSDK( { companyId: companyId, fetch } );
    };

    const createRecognition = async ( recognition )  => {
        return sdk.recognitionService.createRecognition( recognition );
    };

    const searchParticipants = async ( searchText, filters )  => {
        return sdk.rosterService.genericSearchPersons( { searchText, personProperties: [ 'emails', 'attributes' ] } );
    };

    const getPersonDetail = async ( personId ) => {
        const personProperties = [ 'nodes' ];
        return sdk.rosterService.getPersonDetailed( personId, personProperties );
    };

    const getLogosAndColors = async () => {
        return sdk.brandingService.getLogosAndColors();
    };

    const getPointBalance = async ( personId ) => {
        return sdk.cashierService.getPointBalance( personId );
    };

    const getMenuItems = async ( person ) => {
        return sdk.catalogService.getMenuItems( person );
    };

    const getMarketplaceUrl = async ( personId, landingPage ) => {
        return sdk.catalogService.getMarketplaceUrl( personId, landingPage );
    };

    const searchProgramsAndRewardChoices = async ( filters ) => {
        return sdk.recognitionService.searchProgramsAndRewardChoices( filters );
    };

    return {
        createRecognition,
        getPersonDetail,
        getPointBalance,
        getLogosAndColors,
        getMenuItems,
        getMarketplaceUrl,
        searchParticipants,
        recognitionServiceRefresh,
        searchProgramsAndRewardChoices
    };
}

export default new RecognitionService();
